module.exports = __webpack_public_path__ + "static/img/logo.298f71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/logo.png
// module id = ZtoW
// module chunks = 18